import { Request } from '@/classes/Request.ts'

export interface EnrollmentReactivationRequestResponse {
  success: boolean
  data?: {
    // A fresh request was recorded and the district notified.
    requested: boolean
    // A request was already logged today (rate-limited to once per day).
    already_requested: boolean
  }
  failure_reason?: string
}

/**
 * SOW-43: ask the district for a new invitation once this one has expired.
 * Token-authenticated, public. The request is recorded + the district notified
 * server-side; it does NOT reactivate the link (an admin performs the extend),
 * and it is rate-limited to once per day per invitation.
 * POST /api/enrollment/invitation/{token}/request-reactivation
 */
export const enrollmentRequestReactivation = async (
  token: string
): Promise<EnrollmentReactivationRequestResponse> => {
  const response = await new Request().post(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/request-reactivation`,
    {}
  )
  return response.data
}
